/*
 * Copyright (c) SEQTA Software (a division of Saron Education Ltd.) 2016.
 *
 * Created by simon on 2016-09-07
 */

import React from 'react';
import './NumberInput.css';

/**
 * An input field for numeric input that behaves similar to input[type=number], except consistent in all browsers and
 * with nice styling.
 *
 * Has decrement button to the left, increment to the right and allows use of mousewheel to change value.
 */
export const NumberInput = props => (
	<div className={`NumberInput ${props.extraClass || ''} ${props.disabled ? 'disabled' : ''}`}>
		{!props.disabled && <button onClick={() => _decrement(props)}>-</button>}
		<input
			type="text"
			size={6}
			placeholder={props.placeholder || ''}
			onChange={e => _onChange(props, e)}
			value={(props.value || props.value === 0) ? Number((props.value && props.value.replace) ? props.value.replace(/\D/g, '') : props.value) : ''}
			disabled={props.disabled}
		/>
		{!props.disabled && <button onClick={() => _increment(props)}>+</button>}
	</div>
);

export default NumberInput;

/**
 * Constraint the value based on the minimum boundary and return the minimum value if value is less than the minimum value, otherwise, the input value.
 * @param min The minimum value
 * @param value The input value
 * @private
 */
export const _minConstraint = (min, value) => (((min || min === 0) && min > value) ? min : value);
/**
 * Constraint the value based on the maximum boundary and return the maximum value if value is more than the maximum value, otherwise, the input value.
 * @param max The maximum value.
 * @param value The input value
 * @private
 */
export const _maxConstraint = (max, value) => (((max || max === 0) && max < value) ? max : value);

/**
 * User is attempting to increment the value.
 * @param props
 * @private
 */
const _increment = props => {
	if (props.onChange) props.onChange(_maxConstraint(props.max, (props.value || 0) + 1));
};

/**
 * User is attempting to decrement the value.
 * @param props
 * @private
 */
const _decrement = props => {
	if (props.onChange) props.onChange(_minConstraint(props.min, (props.value || 0) - 1));
};

/**
 * User has changed the value by typing
 * @param props
 * @param event
 * @private
 */
export const _onChange = (props, event) => {
	// NOTE -- Doesn't handle negative values very well currently.
	const txtValue = event.target.value.replace(/[^\d]+/g, '');
	const newValue = (txtValue !== '' ? Number(txtValue) : null);
	if (props.onChange) props.onChange(_maxConstraint(props.max, _minConstraint(props.min, newValue)));
};


// WEBPACK FOOTER //
// ./src/widgets/NumberInput.js